export const ActionTypes = {
    UPDATE_SCHEDULE_STARTED: "UPDATE_SCHEDULE_STARTED",
    UPDATE_SCHEDULE_SUCCESS: "UPDATE_SCHEDULE_SUCCESS",
    UPDATE_SCHEDULE_FAILED: "UPDATE_SCHEDULE_FAILED",
    UPDATE_SELECTED_CHANNEL: "UPDATE_SELECTED_CHANNEL",
};

export function updateSchedule(channelId) {
    return (dispatch) => {
        dispatch({
            type: ActionTypes.UPDATE_SCHEDULE_STARTED,
        });

        return fetchData(channelId)
            .then((schedulesForChannel) =>
                dispatch({
                    type: ActionTypes.UPDATE_SCHEDULE_SUCCESS,
                    data: { [channelId]: schedulesForChannel },
                })
            )
            .catch((error) => {
                console.error("Error fetching schedule data: ", error);
                dispatch({
                    type: ActionTypes.UPDATE_SCHEDULE_FAILED,
                    error,
                });
            });
    };
}

export function updateSelectedChannel(channelId) {
    return {
        type: ActionTypes.UPDATE_SELECTED_CHANNEL,
        channelId,
    };
}

export function fetchData(channelId) {
    return fetch(`/multimedia/api/schedules/channel/${channelId}`, {
        credentials: "same-origin",
    }).then((response) => {
        if (response.status >= 300) {
            throw new Error(`Invalid status code: ${response.status}`);
        }

        return response.json();
    });
}

const exported = {
    ActionTypes,
    updateSchedule,
    updateSelectedChannel,
    fetchData,
};

export default exported;
